import { gql } from 'react-apollo';
import { full } from '../../../../graphql/fragments/user';

export const submitSuccessReport = gql`
  mutation submitSuccessReport($input: SubmitSuccessReportInput!) {
    submitSuccessReport(input: $input) {
      successReport: success_report {
        id
        type
        title
        text
        author {
          ...allUserFields
        }
      }
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/successReports/mutations/submitSuccessReport.js